// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import { Modal, Pressable, StyleSheet, View } from 'react-native';
import { Text } from '@/components/Themed';
import appColors from '@/theme/colors';

type Props = {
  visible: boolean;
  title: string;
  message: string;
  confirmLabel: string;
  cancelLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
};

export default function ConfirmDialog({ visible, title, message, confirmLabel, cancelLabel, onConfirm, onCancel }: Props) {
  return (
    <Modal visible={visible} transparent animationType="fade" onRequestClose={onCancel}>
      <View style={styles.overlay}>
        <View style={styles.dialog}>
          <Text style={styles.title}>{title}</Text>
          <Text style={styles.message}>{message}</Text>
          <View style={styles.actions}>
            <Pressable style={styles.cancelButton} onPress={onCancel}>
              <Text style={styles.cancelText}>{cancelLabel}</Text>
            </Pressable>
            <Pressable style={styles.confirmButton} onPress={onConfirm}>
              <Text style={styles.confirmText}>{confirmLabel}</Text>
            </Pressable>
          </View>
        </View>
      </View>
    </Modal>
  );
}

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: appColors.accent.overlay,
    justifyContent: 'center',
    alignItems: 'center',
  },
  dialog: {
    backgroundColor: appColors.surface.elevated,
    borderRadius: 16,
    padding: 24,
    minWidth: 320,
    maxWidth: 420,
    borderWidth: 1,
    borderColor: appColors.border.default,
  },
  title: {
    fontSize: 18,
    fontWeight: '700',
    color: appColors.text.heading,
    marginBottom: 8,
  },
  message: {
    fontSize: 14,
    color: appColors.text.secondary,
    marginBottom: 20,
    lineHeight: 20,
  },
  actions: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    gap: 12,
  },
  cancelButton: {
    paddingHorizontal: 16,
    paddingVertical: 10,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: appColors.border.default,
    backgroundColor: appColors.surface.base,
  },
  cancelText: {
    fontSize: 14,
    fontWeight: '600',
    color: appColors.text.secondary,
  },
  confirmButton: {
    paddingHorizontal: 16,
    paddingVertical: 10,
    borderRadius: 10,
    backgroundColor: appColors.status.danger,
  },
  confirmText: {
    fontSize: 14,
    fontWeight: '700',
    color: appColors.text.onStrong,
  },
});
